import { useState } from "react";
import { toast } from "sonner";
import { Landmark } from "lucide-react";
import { api } from "@/lib/api";
import { getStripe } from "@/lib/billing";
import { Btn } from "@/components/PortalPage";

// Stripe Financial Connections flow that saves a bank for royalty auto-draft.
export const BankConnect = ({ setupPath, confirmPath, onDone, label = "CONNECT BANK FOR AUTO-DRAFT", testId = "bank-connect-btn", onBehalf = false, practice = false }) => {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      if (practice) {
        const res = await api("/billing/practice/bank", { method: "POST" });
        toast.success("Practice bank connected. No real bank was used.");
        onDone?.(res);
        return;
      }
      const s = await api(setupPath, { method: "POST" });
      const stripe = await getStripe(s.publishable_key);
      const { setupIntent, error } = await stripe.collectBankAccountForSetup({
        clientSecret: s.client_secret,
        params: { payment_method_type: "us_bank_account", payment_method_data: { billing_details: { name: s.name, email: s.email } } },
      });
      if (error) throw new Error(error.message);
      if (setupIntent.status === "requires_payment_method") throw new Error("Bank connection was cancelled.");
      let si = setupIntent;
      if (si.status === "requires_confirmation") {
        const r = await stripe.confirmUsBankAccountSetup(s.client_secret);
        if (r.error) throw new Error(r.error.message);
        si = r.setupIntent;
      }
      const res = await api(confirmPath, { method: "POST", body: { setup_intent_id: si.id } });
      toast.success(res.bank_status === "active" ? "Bank connected. Royalty auto-draft is on." : "Bank added. Verification is pending.");
      onDone?.(res);
    } catch (e) {
      toast.error(e.message || "Couldn't connect the bank");
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="space-y-2">
      <Btn onClick={run} busy={busy} data-testid={testId}><Landmark size={16} /> {label}</Btn>
      <p className="text-[11px] leading-4 text-[#888]" data-testid="bank-mandate-text">
        {onBehalf
          ? "Only connect a franchisee's bank with their permission (for example, while on the phone with them). They authorize ALR to debit it by ACH for the 10% royalty and 1% marketing fee each time a customer payment is applied, per their Franchise Agreement."
          : "By connecting, you authorize ALR to debit this account by ACH for the 10% royalty and 1% marketing fee each time a customer payment is applied to an invoice, per your Franchise Agreement. You can update this account any time."}
      </p>
    </div>
  );
};
